import React, { useState, useEffect } from "react";
import Header from "../../../components/header1/Header1";
import Footer from "../../../components/footer/Footer";
import { sendCollegeAndCoordinatorDetails, getCollegeData } from "../../../services/studentportalapis";

function CollegeManagement() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [isAddCollegeModalOpen, setIsAddCollegeModalOpen] = useState(false);

  const toggleAddCollegeModal = () => {
    setIsAddCollegeModalOpen((prev) => !prev);
  };

  // Function to toggle the modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const getCollegeDataLocal = async () => {
      const collegeData = await getCollegeData();
      collegeData.map((college) =>{
        let branchNames = college.branches.map((branch) => branch.branchName)
        college.branches = branchNames;
      } ) ;
      setColleges(collegeData);
    };
    getCollegeDataLocal();
  }, []);
  // const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

  const [collegeDetails, setCollegeDetails] = useState({
    collegeName: "",
    collegeCity: "",
    collegeState: "",
    university: "",
    collegeProfilePhoto: null, // Store the image file
    profilePhotoPreview: null, // Store the image preview URL
    branches: [],
    coordinators: [],
  });
  const [branchesInput, setBranchesInput] = useState([]);
  const [newBranch, setNewBranch] = useState(""); // Temporary input for a new branch
  const [coordinatorDetails, setCoordinatorDetails] = useState({
    coordinatorName: "",
    coordinatorPosition: "",
    coordinatorEmail: "",
    coordinatorPhoneNo: "",
    coordinatorLinkedIn: "",
    coordinatorBio:"",
    areaOfInterest:"",
    profilePhoto:null
  });



  const [colleges, setColleges] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editCoordinatorIndex, setEditCoordinatorIndex] = useState(null); // For editing coordinator
  const [profilePhoto, setProfilePhoto] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name) {
      setCollegeDetails((prevDetails) => ({
        ...prevDetails,
        [name]: value, // Dynamically update the state without triggering an infinite loop
      }));
    }
  };

  const handleCoordinatorInputChange = (e) => {
    const { name, value } = e.target;
    setCoordinatorDetails({ ...coordinatorDetails, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setCollegeDetails({
        ...collegeDetails,
        collegeProfilePhoto: file,
        profilePhotoPreview: previewUrl,
      });
    }
  };

  const handleAddBranch = () => {
    if (branchesInput.trim()) {
      setCollegeDetails((prev) => ({
        ...prev,
        branches: [...prev.branches, branchesInput.trim()],
      }));
      setBranchesInput([]);
    }
  };

  const handleEditBranch = (value, index) => {
    const updatedBranches = [...collegeDetails.branches];
    updatedBranches[index] = value;
    setCollegeDetails({ ...collegeDetails, branches: updatedBranches });
  };

  const handleDeleteBranch = (index) => {
    setCollegeDetails((prev) => ({
      ...prev,
      branches: prev.branches.filter((_, i) => i !== index),
    }));
  };

  const addBranch = () => {
    if (!newBranch.trim()) return alert("Branch name cannot be empty.");
    if (collegeDetails.branches.includes(newBranch)) {
      return alert("This branch is already added.");
    }

    setCollegeDetails((prev) => ({
      ...prev,
      branches: [...prev.branches, newBranch],
    }));
    setNewBranch(""); // Clear the input field
  };

  const deleteBranch = (index) => {
    setCollegeDetails((prev) => ({
      ...prev,
      branches: prev.branches.filter((_, i) => i !== index),
    }));
  };

  const handleAddCoordinator = () => {
    if (
      coordinatorDetails.coordinatorName &&
      coordinatorDetails.coordinatorEmail
    ) {
      const updatedCoordinators = [...collegeDetails.coordinators];
      if (editCoordinatorIndex !== null) {
        // Edit existing coordinator
        updatedCoordinators[editCoordinatorIndex] = coordinatorDetails;
        setEditCoordinatorIndex(null); // Reset the edit mode
        setIsModalOpen(false);
      } else {
        // Add new coordinator
        updatedCoordinators.push(coordinatorDetails);
        setIsModalOpen(false);
      }

      setCollegeDetails({
        ...collegeDetails,
        coordinators: updatedCoordinators,
      });
      setCoordinatorDetails({
        coordinatorName: "",
        coordinatorPosition: "",
        coordinatorEmail: "",
        coordinatorPhoneNo: "",
        coordinatorLinkedIn: "",
      });
    } else {
      alert("Please fill in required fields for the coordinator.");
    }
  };

  const handleSaveCollege = async () => {
    if (collegeDetails.collegeName && collegeDetails.university) {
      if (editIndex != null) {
        const updatedColleges = [...colleges];
        updatedColleges[editIndex] = collegeDetails;
        setColleges(updatedColleges);
        setEditIndex(null);
        setIsAddCollegeModalOpen(false);
      } else {
        setColleges([...colleges, collegeDetails]);
        setIsModalOpen(false);
        setIsAddCollegeModalOpen(false);
      }
      try{
        console.log(collegeDetails.coordinators);
        const formData = new FormData();
        formData.append("collegeName", collegeDetails.collegeName);
        formData.append("collegeCity", collegeDetails.collegeCity);
        formData.append("collegeState", collegeDetails.collegeState);
        formData.append("university", collegeDetails.university);
        formData.append("collegeProfilePhoto", collegeDetails.profilePhoto);
        formData.append("branches", collegeDetails.branches);
        formData.append("coordinators", JSON.stringify(collegeDetails.coordinators));
     

          const transformedCollegeDetails = {
            ...collegeDetails,
            branches: collegeDetails.branches.map(branch => ({ branchName: branch })),
          };  
        // const collegeData = {
        //   collegeName: name,
        //   email: email,
        //   age: age,
        // };
        
        console.log(transformedCollegeDetails);
        const response = await sendCollegeAndCoordinatorDetails(transformedCollegeDetails);

        if (response.success) {
          console.log("Data saved successfully");
        } else {
          alert("College details are not saved.");
        }

      }catch(error){
       console.log("Error While saving college and coordinator data.");
      }
      

      setCollegeDetails({
        collegeName: "",
        collegeCity: "",
        collegeState: "",
        university: "",
        collegeProfilePhoto: null,
        profilePhotoPreview: null,
        branches: [],
        coordinators: [],
      });

    } else {
      alert("Please fill in required fields");
    }
  };

  // const handleAddCollege = () => {
  //   setCollegeDetails({
  //     collegeName: "",
  //     collegeCity: "",
  //     collegeState: "",
  //     university: "",
  //     profilePhoto: null,
  //     profilePhotoPreview: null,
  //     branches: [],
  //     coordinators: [],
  //   });
  //   setEditIndex(null);
  // };

  const handleEditCollege = (index) => {
    const collegeToEdit = colleges[index];
    setCollegeDetails(collegeToEdit);
    setEditIndex(index);
    setIsAddCollegeModalOpen(true);
  };

  const handleDeleteCollege = (index) => {
    setColleges(colleges.filter((_, i) => i !== index));
  };
  const handleEditCoordinator = (index) => {
    setCoordinatorDetails(collegeDetails.coordinators[index]);
    setEditCoordinatorIndex(index);
    toggleModal(true);
  };

  const handleDeleteCoordinator = (index) => {
    const updatedCoordinators = collegeDetails.coordinators.filter(
      (_, i) => i !== index
    );
    setCollegeDetails({ ...collegeDetails, coordinators: updatedCoordinators });
  };

  const saveCollege = () => {
    // Save college logic
    closeModal();
  };

  const closeModal = () => setIsModalOpen(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const base64Image = await convertToBase64(file);
    setProfilePhoto(file);
    setCollegeDetails((prev) => ({
      ...prev,
      collegeProfilePhoto: base64Image,
    }))
    // console.log(file);
  };

  const handleFileUploadForCoordinator = async (e) => {
    const file = e.target.files[0];
    const base64Image = await convertToBase64(file);
    
    setCoordinatorDetails((prev) => ({
      ...prev,
      profilePhoto: base64Image,
    }))
    // console.log(file);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Read file as Data URL
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <div className="md:mx-20 sm:mx-10">
      <Header />
      <div className="min-h-screen bg-gray-100 p-8">
        <div className="max-w-5xl mx-auto bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            <h1 className="mb-4 text-3xl font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
              <span className="text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">
                College
              </span>{" "}
              Management.
            </h1>
          </h2>

          <button
            onClick={toggleAddCollegeModal}
            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Add College
          </button>

          {/* Add College Modal */}

          {isAddCollegeModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg overflow-y-auto max-h-[80vh]">
              <h2 className="text-2xl font-semibold mb-4">Add College</h2>

              {/* College Name */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  College Name
                </label>
                <input
                  type="text"
                  name="collegeName" // Add name here
                  placeholder="Enter College Name"
                  className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={collegeDetails.collegeName || ""}
                  onChange={handleInputChange}
                />
              </div>

              {/* College City */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  College City
                </label>
                <input
                  type="text"
                  name="collegeCity" // Add name here
                  placeholder="Enter College City"
                  className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={collegeDetails.collegeCity || ""}
                  onChange={handleInputChange}
                />
              </div>

              {/* College State */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  College State
                </label>
                <input
                  type="text"
                  name="collegeState" // Add name here
                  placeholder="Enter College State"
                  className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={collegeDetails.collegeState || ""}
                  onChange={handleInputChange}
                />
              </div>

              {/* University */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  University
                </label>
                <input
                  type="text"
                  name="university"
                  placeholder="Enter University Name"
                  className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={collegeDetails.university || ""}
                  onChange={
                    handleInputChange
                  }
                />
              </div>

              {/* College Profile Photo */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  College Profile Photo
                </label>
                <input
                  type="file"
                  className="mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md cursor-pointer focus:ring-blue-500 focus:border-blue-500"
                  onChange={(e) => handleFileUpload(e)}
                />
              </div>

              {/* Branch Management */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Branches
                </label>
                <div className="flex space-x-2 mb-4">
                  <input
                    type="text"
                    placeholder="Enter Branch Name"
                    className="mt-1 flex-grow p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    value={newBranch}
                    onChange={(e) => setNewBranch(e.target.value)}
                  />
                  <button
                    type="button"
                    className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                    onClick={addBranch}
                  >
                    Add
                  </button>
                </div>
                <div className="flex flex-wrap gap-2">
                  {collegeDetails.branches.map((branch, index) => (
                    <div
                      key={index}
                      className="relative bg-gray-100 text-gray-800 rounded-md p-4 shadow-md w-fit flex items-center"
                    >
                      <button
                        type="button"
                        className="absolute top-1 right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center hover:bg-red-600"
                        onClick={() => deleteBranch(index)}
                      >
                        ✖
                      </button>
                      <span className="pr-8">{branch}</span>
                    </div>
                  ))}
                </div>
              </div>

{/* Coordinator pop up */}
              <div>
                {/* Coordinator Form */}
                <button
                  type="button"
                  onClick={toggleModal}
                  className="mt-4 px-4 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
                >
                  Add Coordinator
                </button>

                {/* Pop up window */}
                {isModalOpen && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-1/3 p-6">
                      {/* Modal Header */}
                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">
                          Add Coordinator
                        </h2>
                        <button
                          onClick={toggleModal}
                          className="text-gray-500 hover:text-red-500"
                        >
                          ✖
                        </button>
                      </div>

                      {/* Modal Content */}
                      <div>
                        <div className="mt-4 space-y-4">
                          <input
                            type="text"
                            name="coordinatorName"
                            value={coordinatorDetails.coordinatorName}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator Name"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                            required
                          />
                          <input
                            type="text"
                            name="coordinatorPosition"
                            value={coordinatorDetails.coordinatorPosition}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator Position"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                          />
                          <input
                            type="email"
                            name="coordinatorEmail"
                            value={coordinatorDetails.coordinatorEmail}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator Email"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                            required
                          />
                          <input
                            type="text"
                            name="coordinatorPhoneNo"
                            value={coordinatorDetails.coordinatorPhoneNo}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator Phone Number"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                          />
                          <input
                            type="text"
                            name="coordinatorLinkedIn"
                            value={coordinatorDetails.coordinatorLinkedIn}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator LinkedIn"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                          />
                          <input
                            type="text"
                            name="coordinatorBio"
                            value={coordinatorDetails.coordinatorBio}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Coordinator Bio"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                          />
                          <input
                            type="text"
                            name="areaOfInterest"
                            value={coordinatorDetails.areaOfInterest}
                            onChange={handleCoordinatorInputChange}
                            placeholder="Area Of Interest"
                            className="border p-3 rounded focus:ring focus:ring-blue-300"
                          />
                          <input
                            type="file"
                            className="mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md cursor-pointer focus:ring-blue-500 focus:border-blue-500"
                            onChange={(e) => handleFileUploadForCoordinator(e)}
                          />
                          <button
                            type="button"
                            onClick={handleAddCoordinator}
                            className="mt-4 px-4 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
                          >
                            {editCoordinatorIndex !== null
                              ? "Update Coordinator"
                              : "Save Coordinator"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-4">
                  {collegeDetails.coordinators.map((coordinator, Idx) => (
                    <div
                      key={Idx}
                      className="flex flex-wrap mb-4 border border-gray-300 rounded-md shadow-sm bg-white"
                    >
                      <p>
                        <strong>{coordinator.coordinatorName}</strong> (
                        {coordinator.coordinatorPosition})
                      </p>
                      <p>Email: {coordinator.coordinatorEmail}</p>
                      <p>Phone: {coordinator.coordinatorPhoneNo}</p>
                      <p>LinkedIn: {coordinator.coordinatorLinkedIn}</p>

                      <div className="flex  mt-4 space-x-4">
                        <button
                          onClick={() =>
                            handleEditCoordinator(Idx) &&
                            toggleModal
                          }
                          className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                        >
                          Edit Coordinator
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteCoordinator(Idx)
                          }
                          className="ml-4 mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                        >
                          Delete Coordinator
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>





              {/* Modal Actions */}
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 rounded-md hover:bg-gray-600"
                  onClick={toggleAddCollegeModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  onClick={handleSaveCollege}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
  )}


          {/* Colleges List */}
          <div className="mt-10">
            <h3 className="text-xl font-semibold text-gray-700">
              Colleges List
            </h3>
            <div className="mt-4 space-y-4 ">
              {colleges.map((college, idx) => (
                <div
                  key={idx}
                  className="p-4 border rounded-md shadow-sm bg-white"
                >
                  <h4 className="text-2xl font-bold">{college.collegeName}</h4>
                  <p>
                    {college.collegeCity}, {college.collegeState}
                  </p>
                  <p>{college.university}</p>

                  <div>
                    <h5 className="font-semibold m-2">Coordinators:</h5>
                    {college.coordinators && college.coordinators.length > 0 ? (
                      college.coordinators.map(
                        (coordinator, coordinatorIdx) => (
                          <div
                            key={coordinatorIdx}
                            className="flex mb-4 flex-wrap border border-gray-300 rounded-md shadow-sm bg-white"
                          >
                            <p>
                              <strong>{coordinator.coordinatorName}</strong> (
                              {coordinator.coordinatorPosition})
                            </p>
                            <p>Email: {coordinator.coordinatorEmail}</p>
                            <p>Phone: {coordinator.coordinatorPhoneNo}</p>
                            <p>LinkedIn: {coordinator.coordinatorLinkedIn}</p>

                            {/* <button
                              onClick={() =>
                                handleEditCoordinator(
                                  coordinator.coordinatorIdx
                                )
                              }
                              className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                            >
                              Edit Coordinator
                            </button>
                            <button
                              onClick={() =>
                                handleDeleteCoordinator(
                                  coordinator.coordinatorIdx
                                )
                              }
                              className="ml-4 mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                            >
                              Delete Coordinator
                            </button> */}
                          </div>
                        )
                      )
                    ) : (
                      <p>No coordinators added</p>
                    )}
                  </div>

                  <button
                    onClick={() => handleEditCollege(idx)}
                    className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                  >
                    Edit College
                  </button>
                  <button
                    onClick={() => handleDeleteCollege(idx)}
                    className="ml-4 mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                  >
                    Delete College
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CollegeManagement;
